import { GetAllCoursesInDto, GetAllCoursesOutDto } from "../../../types/course.dto";

export const GET_ALL_COURSES = "GET_ALL_COURSES";
export const GET_ALL_COURSES_SUCCESS = "GET_ALL_COURSES_SUCCESS";
export const GET_ALL_COURSES_ERROR = "GET_ALL_COURSES_ERROR";
export const RESET_GET_ALL_COURSES = "RESET_GET_ALL_COURSES";

export interface GetAllCourses {
  type: typeof GET_ALL_COURSES;
  payload: GetAllCoursesOutDto;
}

export interface GetAllCoursesSuccess {
  type: typeof GET_ALL_COURSES_SUCCESS;
  payload: GetAllCoursesInDto;
}

export interface GetAllCoursesError {
  type: typeof GET_ALL_COURSES_ERROR;
  payload: string | boolean;
}

export interface ResetGetAllCourses {
  type: typeof RESET_GET_ALL_COURSES;
  payload: null;
}

export interface State {
  data: GetAllCoursesInDto | null;
  states: {
    loading: boolean;
    success: boolean;
    error: boolean | string;
  };
}

export const initialState: State = {
  data: null,
  states: {
    loading: false,
    success: false,
    error: false,
  },
};

export type Actions =
  | GetAllCourses
  | GetAllCoursesSuccess
  | GetAllCoursesError
  | ResetGetAllCourses;
